<!-- Overlay -->
@if (isOpen) {
  <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -- pre-existing pattern; accessibility tracked under COL-37 -->
  <div
    class="fixed inset-0 bg-black/40 backdrop-blur-sm transition-opacity duration-300"
    (click)="close()"
    style="z-index: 9998;"
  ></div>
}

<!-- Off-Canvas Drawer -->
<div
  class="fixed top-0 right-0 h-screen w-full h-full sm:w-[420px] md:w-[460px] lg:w-[480px]
         bg-white shadow-2xl border-l border-black/10 flex flex-col transform transition-transform duration-300 ease-in-out
         rounded-none sm:rounded-l-2xl"
  [ngClass]="isOpen ? 'translate-x-0' : ' hidden translate-x-full'"
  style="z-index: 9999;"
  >

  <!-- Header -->
  <header class="flex items-center justify-between px-5 py-4 bg-slate-600 text-white rounded-tl-2xl">
    <div class="flex-1 min-w-0">
      <h2 class="text-xs uppercase opacity-80 tracking-wide">{{ moduleName }}</h2>
      <h1 class="text-base font-semibold truncate">
        {{ record?.title || record?.name || 'Details' }}
      </h1>
    </div>
    <button (click)="close()" class="hover:opacity-80 p-1">
      <mat-icon svgIcon="c:x"></mat-icon>
    </button>
  </header>

  <!-- Action Buttons -->
  <div class="flex gap-2 flex-wrap px-5 py-3 bg-white border-b border-black/10">
    <button
      class="bg-slate-600 hover:bg-slate-700 text-white text-xs sm:text-sm font-medium px-4 py-1.5 rounded-md shadow-sm flex-1 sm:flex-none"
      >
      Edit {{moduleName}}
    </button>
  </div>

  <!-- Scrollable Content -->
  <main class="flex-1 overflow-y-auto px-5 py-5 space-y-6 bg-gray-50" style="scrollbar-width: thin;">

    <!-- Information Section -->
    <section class="bg-white rounded-xl shadow-sm border border-black/10 p-5">
      <h3 class="text-[15px] font-semibold text-black mb-4">Information</h3>
      <div class="grid grid-cols-1 gap-3 text-sm text-black">
        <div>
          <div class="text-black/60">Name</div>
          <div class="font-semibold">{{ record?.name || 'N/A' }}</div>
        </div>
        <div>
          <div class="text-black/60">Email</div>
          <div class="font-semibold">{{ record?.email || 'N/A' }}</div>
        </div>
        <div>
          <div class="text-black/60">Project</div>
          <div class="font-semibold">{{ record?.project ?? 'N/A' }}</div>
        </div>
      </div>
    </section>

  </main>
</div>